import { Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { notFoundPath } from 'common/config/urls';
import {
  DOCUMENTS_URL_PARAM,
  QUESTIONS_URL_PARAM,
} from 'common/constants/process-management';
import { SecurePortalParams } from 'common/types/reactRouter';
import ProcessManagementPortal from './ProcessManagementPortal';
import { ProcessManagementProps } from './ProcessManagementProps.props';

const ProcessManagement = (props: ProcessManagementProps) => {
  const { processType } = useParams<SecurePortalParams>();
  const navigate = useNavigate();

  if (processType !== DOCUMENTS_URL_PARAM && processType !== QUESTIONS_URL_PARAM) {
    navigate(notFoundPath);
    return null;
  }

  return (
    <Box>
      <Box display="flex">
        <Box flex={1} p={3}>
          <ProcessManagementPortal />
        </Box>
      </Box>
    </Box>
  );
};

export default ProcessManagement;
